if (!customElements.get('trust-indicators-slider')) {
  class TrustIndicatorsSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};
      this.initSlider(swiperOptions);
    }

    initSlider(swiperOptions) {
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const mobileAutoplay = prefersReducedMotion
        ? false
        : {
            delay: 0,
            disableOnInteraction: false,
          };

      this.slider = new Swiper(this, {
        slidesPerView: 'auto',
        spaceBetween: swiperOptions.spaceBetweenMobile || 0,
        loop: true,
        speed: 6000,
        autoplay: mobileAutoplay,
        allowTouchMove: true,
        breakpoints: {
          750: {
            enabled: true,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 0,
            slidesPerView: 2,
            loop: true,
            speed: 600,
            autoplay: false,
          },
          990: {
            enabled: true,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 0,
            slidesPerView: 3,
            loop: false,
            speed: 600,
            autoplay: false,
            allowTouchMove: false,
          }
        }
      });
    }
  }

  customElements.define('trust-indicators-slider', TrustIndicatorsSlider);
}
